<template>
  <div>
    <div>
      <h1>{{ title }}</h1>
      <h3 v-if="subTitle" class="vs-subtitle">
        {{ subTitle }}
      </h3>
    </div>
    <div class="level">
      <slot name="leftElements" />
      <div class="level-right">
        <slot name="rightElements" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped lang="scss">
.level-right {
  align-self: flex-start;
  min-width: 25%;
}

.level-left {
  max-width: 75%;
}

.vs-subtitle {
  color: $gray-500;
}
</style>
